import { render, staticRenderFns } from "./ConfirmEmail.vue?vue&type=template&id=247f2e5e&"
import script from "./ConfirmEmail.vue?vue&type=script&lang=js&"
export * from "./ConfirmEmail.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmEmail.vue?vue&type=style&index=0&id=247f2e5e&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports